<template>
  <AppGenericInput
    v-model="givenValue"
    component-name="v-autocomplete"
    :items="qualifications"
    v-bind="$attrs"
    hide-no-data
    :menu-props="menuProps"
    data-test="qualificitaions"
    item-value="id"
    item-text="name"
  />
</template>

<script>
import AppGenericInput from "@AppSelects/AppGenericInput.vue";
import { useProfQualificationGroupHelper } from "@composables/masterdata/person/profQualificationGroups";
import { useProfQualificationHelper } from "@composables/masterdata/person/profQualifications";

export default {
  name: "AppSelectPersonQualifications",
  components: { AppGenericInput },
  props: {
    value: {
      type: [String, Array, Object],
      default: null
    },
    menuProps: {
      type: Object,
      default: null
    }
  },
  setup() {
    const masterProfQualificationGroups = useProfQualificationGroupHelper();
    const masterProfQualifications = useProfQualificationHelper();
    return {
      ...masterProfQualificationGroups,
      ...masterProfQualifications
    };
  },
  computed: {
    givenValue: {
      get() {
        return this.value;
      },
      set(v) {
        this.$emit("input", v);
      }
    },
    qualifications() {
      const items = [];

      this.masterProfQualificationGroupsActive.forEach(group => {
        items.push({ header: group.name });

        this.masterProfQualificationsActive.forEach(qualification => {
          if (qualification.profQualificationGroupId == group.id)
            items.push({
              name: qualification.name,
              id: qualification.id,
              group: group.name
            });
        });

        items.push({ divider: true });
      });

      return items;
    }
  }
};
</script>
